import MachineDetailContainer from 'components/feature/machine/detail/MachineDetailContainer';

const MachineDetailPage = () => {
  return <MachineDetailContainer />;
};
export default MachineDetailPage;
